module.exports = __webpack_public_path__ + "static/media/crusador_chainmail.c59fd588.png";